import { useState } from "react";
import FilterData from "./FilterData";
import HolidayCalendarDetails from "./HolidayCalendarDetails";

const HolidayCalendar = () => {
  const [open, setOpen] = useState<boolean>(false);
  const handleClick = (): void => {
    setOpen(true);
  };  
  const handleFilterChange = () => {
    setOpen(false);
  };
  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        Holiday Calendar
      </h1>
      <FilterData handleClick={handleClick} handleFilterChange={handleFilterChange}/>
      {open && 
        <HolidayCalendarDetails />
      }      
    </div>    
  );
};

export default HolidayCalendar;
